import useAuthentication, { getIsAccessTokenValid } from './useAuthentication';

const useIsAuthenticated = () => {
  const [authentication, , grantType] = useAuthentication();

  return grantType === 'password' && getIsAccessTokenValid(authentication?.access_token);
};

export default useIsAuthenticated;
